import Pagination from "ui/pagination";
import { BtnVisitCamera, BtnDeleteCamera } from "ui/buttons";
import { useContext } from "react";
import { AuthContext } from "context/AuthContext";
import useSWR from "swr";
import { fetchWithParams } from "lib/fetcher";
import { ITEMS_PER_PAGE } from "lib/constants";

export default function CamerasTable({
  orgId,
  siteId,
  nvrId,
  currentPage,
}: {
  orgId: string;
  siteId: string;
  nvrId: string;
  currentPage: number;
}) {
  const offset = currentPage - 1;
  const params = `?${"siteId"}=${siteId}&${"nvrId"}=${nvrId}&${"page.limit"}=${ITEMS_PER_PAGE}&${"page.offset"}=${offset}`;

  const { user } = useContext(AuthContext);
  const { data, error, isLoading } = useSWR(
    [`/camera/cameras${params}`, user.token, orgId],
    ([url, token, orgId]) => fetchWithParams(url, token, orgId),
  );

  if (isLoading) return <div>Loading...</div>;
  if (!data) {
    throw new Error(error);
  }
  if (data) {
    console.log("--- cameras ---", params, data);
  }

  const arrData = data.data;
  const numTotalCustomers = data.page.total;
  const numTotalPages = Math.ceil(Number(numTotalCustomers) / ITEMS_PER_PAGE);

  return (
    <div className="w-full">
      <div className="mt-6 flow-root">
        <div className="overflow-x-auto">
          <div className="inline-block min-w-full align-middle">
            <div className="overflow-hidden rounded-md p-2 md:pt-0">
              <table className="min-w-full rounded-md text-neutral-800 border-separate border-spacing-y-3">
                <tbody>
                  {arrData.map((data: any) => (
                    <tr key={data.id}>
                      <td className="bg-neutral-100 rounded-lg text-sm px-8 py-4">
                        <div>cameraId: {data.id}</div>
                        <div>Mac Address: {data.macAddress}</div>
                        <div>Manufacturer: {data.manufacturer}</div>
                        <div>Model: {data.model}</div>
                        <div>nvrId: {data.nvrId}</div>
                        <div>orgId: {data.orgId}</div>
                        <div>Name: {data.name}</div>
                        <div>RemoteIndex: {data.remoteIndex}</div>
                        <div>SiteId: {data.siteId}</div>
                        <div>SN: {data.sn}</div>
                      </td>
                      <td className="bg-neutral-100 rounded-lg text-sm px-8 py-4">
                        <div className="flex justify-end gap-3">
                          <BtnVisitCamera
                            orgId={orgId}
                            siteId={siteId}
                            nvrId={nvrId}
                            cameraId={data.id}
                          />
                          <BtnDeleteCamera orgId={orgId} cameraId={data.id} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-5 flex w-full justify-center">
        <Pagination totalPages={numTotalPages} />
      </div>
    </div>
  );
}
